var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeTrailsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 45,
    viewBox: "0 0 41 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_427_9336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.48897,
    height: 7.5047,
    rx: 1.74449,
    transform: "matrix(0.689193 0.724578 0.724536 -0.689237 26.8984 11.0399)",
    fill: "#FFCE35"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5096,
    cy: 20.2707,
    rx: 14.7606,
    ry: 14.7615,
    fill: "#EE7233"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.1675,
    y: 10.8763,
    width: 2.68374,
    height: 10.7356,
    rx: 1.34187,
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.8125,
    y: 3.7251,
    width: 3.48907,
    height: 10.7979,
    rx: 1.74454,
    transform: "rotate(-90 14.8125 3.7251)",
    fill: "#FFCE35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_427_9336",
    x: 0.773322,
    y: 0.236084,
    width: 39.4724,
    height: 44.7475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.9757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48785
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_427_9336"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_427_9336",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeTrailsIcon);
export default __webpack_public_path__ + "static/media/time_trails_icon.d1ac31b2c34af6901b0775da6aacf09f.svg";
export { ForwardRef as ReactComponent };